var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconErrorMotivation = function SvgIconErrorMotivation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.9 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.9,
    cy: 4,
    r: 3.5,
    stroke: "#D61E3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D61E3D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.7 2.8 2.4 2.4M6.1 2.8 3.7 5.2"
  })));
};
export { SvgIconErrorMotivation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC44OTk5MDIgNEMwLjg5OTkwMiAxLjc5MDg2IDIuNjkwNzYgMCA0Ljg5OTkgMEM3LjEwOTA0IDAgOC44OTk5IDEuNzkwODYgOC44OTk5IDRDOC44OTk5IDYuMjA5MTQgNy4xMDkwNCA4IDQuODk5OSA4QzIuNjkwNzYgOCAwLjg5OTkwMiA2LjIwOTE0IDAuODk5OTAyIDRaIiBmaWxsPSJ3aGl0ZSIvPgo8Y2lyY2xlIGN4PSI0Ljg5OTkiIGN5PSI0IiByPSIzLjUiIHN0cm9rZT0iI0Q2MUUzRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zLjY5OTcxIDIuNzk5OTlMNi4wOTk3MSA1LjE5OTk5IiBzdHJva2U9IiNENjFFM0QiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4xMDAxIDIuNzk5OTlMMy43MDAxIDUuMTk5OTkiIHN0cm9rZT0iI0Q2MUUzRCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";